import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function displayRulesMainStore(state = initialState, action) {
  switch (action.type) {
    case actions.SET_DISPLAYRULES_MAINSTORE:
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    default:
      return state;
  }
}
